export const DEFAULT_SCROLL_HEIGHT = 500;
export const MINIMUM_SCROLL_HEIGHT = 150;
export const SCROLL_HEIGHT_MARGIN = 150;
export const DEFAULT_TILE_HEIGHT = 100;
